module.exports = __webpack_public_path__ + "img/icon-home-tp-04.b09cbc7c.jpg";